module.exports = __webpack_public_path__ + "img/sscopelogo-header.48a7871d.svg";